import { Button, Row, Col } from 'antd'

import './TaskDrawer.style.less'

interface FooterProps {
  handleCancel?: any
  onFinish?: any
  isLoading?: boolean
  disableSaveButton?: boolean
  saveText?: string
}

function FooterForm(props: FooterProps) {
  const {
    disableSaveButton = false,
    onFinish,
    isLoading,
    handleCancel,
    saveText = 'Submit',
  } = props
  return (
    <Row className="footer">
      <Col span={11}>
        <Button className="button" size="middle" onClick={handleCancel} block>
          Cancel
        </Button>
      </Col>
      <Col span={11} offset={2}>
        <Button
          className="button"
          type="primary"
          size="middle"
          htmlType="submit"
          onClick={onFinish}
          block
          loading={isLoading}
          disabled={disableSaveButton}
        >
          {saveText}
        </Button>
      </Col>
    </Row>
  )
}

export default FooterForm
